import React from "react";
import {useNavigate} from "react-router-dom";
import { ArrowLeft } from 'lucide-react';
export function Header({isBackButtonVisible = false, t}: { isBackButtonVisible?: boolean, t: any}) {
    const navigate = useNavigate();
    return (
        <header className="header">
            {
                isBackButtonVisible &&   <button onClick={() => navigate("/")} className="back-button">
                    <ArrowLeft size={20} /> {t.back}
                </button>
            }
            <img src="/favicon.png" alt="MartTech Logo" className="logo" />
        </header>
    );
}